import React, { useState, useEffect } from "react";
import GooglePayButton from '@google-pay/button-react';
import SmallScreenView from "../../components/smallscreen";
import { Hidden } from "react-awesome-styled-grid";
import { AmountDivideByHundred } from "../../helper";
import {
  FlexContainer,
  H1Text,
} from "../../design";
import PaymentError from "../paymenterror";

type Props = {
  headerText: string,
  payment: Object;
  gpaySecretValues: Object;
  chargeByGooglePay: Function;
  errorMsg: String,
  errorHeader: String,
  gpayError: String,
};

const GooglePay = (props: Props) => {
  const { headerText, payment, chargeByGooglePay, gpayError, errorMsg, errorHeader, gpaySecretValues } = props;
  const [isShowErrorMessage, setShowErrorMessage] = useState(false);

  useEffect(() => {
    if (errorMsg) {
      setShowErrorMessage(true);
    } else setShowErrorMessage(false);
  }, [errorMsg]);

  return (
    <>
      <H1Text
        className="px-4 px-md-4 mb-0"
      >
        <SmallScreenView>
          {"Pay With Google pay"}
        </SmallScreenView>
        <Hidden sm xs>
          {headerText || "Pay With Google pay"}
        </Hidden>
      </H1Text>
      <FlexContainer
        flexDirection="column"
      >
        <div className="px-4 px-md-4 mt-4 mb-4 w-100">
          <div className="row m-0">
            {
              gpaySecretValues ? (
                <GooglePayButton
                  environment={gpaySecretValues && gpaySecretValues.environment}
                  buttonColor="default"
                  buttonType="pay"
                  buttonRadius="4"
                  buttonLocale="en"
                  paymentRequest={{
                    apiVersion: 2,
                    apiVersionMinor: 0,
                    allowedPaymentMethods: [
                      {
                        type: gpaySecretValues && gpaySecretValues.paymentType,
                        parameters: {
                          allowedAuthMethods: gpaySecretValues && gpaySecretValues.allowedAuthMethods,
                          allowedCardNetworks: gpaySecretValues && gpaySecretValues.allowedCardNetworks,
                          billingAddressRequired: true,
                          billingAddressParameters: { format: "FULL", phoneNumberRequired: true }
                        },
                        tokenizationSpecification: {
                          type: gpaySecretValues && gpaySecretValues.acquirerType,
                          parameters: {
                            gateway: gpaySecretValues && gpaySecretValues.gateway,
                            gatewayMerchantId: gpaySecretValues && gpaySecretValues.gatewayMerchantId
                          }
                        }
                      }
                    ],
                    merchantInfo: {
                      merchantId: gpaySecretValues && gpaySecretValues.googlePayMerchantId,
                      merchantName: gpaySecretValues && gpaySecretValues.googlePayMerchantName
                    },
                    transactionInfo: {
                      countryCode: payment.currency.countryAlpha2,
                      currencyCode: payment.currency.name,
                      totalPriceStatus: 'FINAL',
                      totalPrice: payment.tip ? AmountDivideByHundred(payment.amount + payment.tip) : AmountDivideByHundred(payment.amount),
                      totalPriceLabel: 'Total'
                    },
                    emailRequired: true,
                    shippingAddressRequired: true
                  }}
                  onLoadPaymentData={paymentRequest => {
                    chargeByGooglePay(paymentRequest);
                  }}
                />

              ) : (
                <GooglePayButton
                  buttonColor="default"
                  buttonType="pay"
                  environment="TEST"
                  buttonRadius="4"
                  buttonLocale="en"
                  paymentRequest={{
                    apiVersion: 2,
                    apiVersionMinor: 0,
                    allowedPaymentMethods: [
                      {
                        type: 'CARD',
                        parameters: {
                          allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
                          allowedCardNetworks: ["AMEX", "DISCOVER", "INTERAC", "JCB", "MASTERCARD", "VISA"],
                          billingAddressRequired: true,
                          billingAddressParameters: { format: "FULL", phoneNumberRequired: true }
                        },
                        tokenizationSpecification: {
                          type: 'PAYMENT_GATEWAY',
                          parameters: {
                            gateway: 'cardconnect',
                            gatewayMerchantId: '820000003044'
                          }
                        }
                      }
                    ],
                    merchantInfo: {
                      merchantId: "820000003044",
                      merchantName: "Demo Merchant"
                    },
                    transactionInfo: {
                      countryCode: payment.currency.countryAlpha2,
                      currencyCode: payment.currency.name,
                      totalPriceStatus: 'FINAL',
                      totalPrice: AmountDivideByHundred(payment.amount),
                      totalPriceLabel: 'Total'
                    },
                    emailRequired: true,
                    shippingAddressRequired: true
                  }}
                />
              )
            }
          </div>
        </div>
        <div className="px-1 px-md-2">
          {/* {isShowErrorMessage
            ? (<PaymentError header={errorHeader} message={errorMsg} />)
            : gpayError
              ? (<PaymentError header={errorHeader} message={gpayError} />)
              : ''} */}
          { gpayError && (<PaymentError header={errorHeader} message={gpayError} />) }
        </div>
      </FlexContainer>
    </>
  )
}

export default GooglePay;